import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { useRouteParams } from '../hooks/useRouteParams';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';

export enum TransferDirection {
  Incoming,
  Outgoing,
}

export enum TransferType {
  ACH,
  ACATS,
}

export interface TransferDTO {
  description: string;
  transferDate: Date;
  transferDirection: TransferDirection;
  transferId: string;
  transferState: string;
  transferType: TransferType;
}

export interface TransfersListDTO {
  pending: TransferDTO[];
  rejected: TransferDTO[];
}

interface FetchTransfersParams {
  clientId: string;
  managedAccountId: string;
}

const fetchTransfers = ({
  clientId,
  managedAccountId,
}: FetchTransfersParams): Promise<TransfersListDTO> =>
  authFetch(urlWithParams('/Consumer/AchTransfers', { clientId, managedAccountId }));

export const useTransfersQuery = (managedAccountId: string) => {
  const { clientId } = useRouteParams();

  return useQuery(queryKeys.transfers({ clientId, managedAccountId }), () =>
    fetchTransfers({ clientId, managedAccountId }),
  );
};
